import { ChainId, tokens as venusTokens } from '@venusprotocol/chains';

export const tokens = venusTokens[ChainId.BSC_TESTNET];
